import { useEffect, useState, useMemo } from 'react';
import { useDebounce } from 'use-debounce';
import constate from 'constate';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import history from 'routing/history';

const trimSearch = (search = '') => {
  // Only allow one space at the end of search string, so its editable,
  // but so that multiple spaces are not used in search
  const isSpaceAtEnd = search.length > 1 && search.slice(-1) === ' ';
  return `${search.trim()}${isSpaceAtEnd ? ' ' : ''}`;
};

const useSearch = () => {
  const location = useLocation();
  const urlSearch = useMemo(() => queryString.parse(location.search).search, []);
  const [search, setSearch] = useState(urlSearch || '');
  const trimmedSearch = trimSearch(search);
  const [debouncedSearch] = useDebounce(trimmedSearch, 300);

  // Keep url search param updated
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (!debouncedSearch) {
      // Clear search param if not searching
      searchParams.delete('search');
    } else {
      searchParams.set('search', debouncedSearch);
    }
    history.replace(`${location.pathname}?${searchParams.toString()}`);
  }, [debouncedSearch]);

  return {
    search: trimmedSearch,
    setSearch,
    debouncedSearch
  };
};

const [SearchProvider, useSearchContext] = constate(useSearch);

export { SearchProvider, useSearchContext };
